module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event",
    class: _vm.eventClass,
    style: (_vm.eventStyle),
    attrs: {
      "id": 'event-' + _vm.event.id
    },
    on: {
      "click": [function($event) {
        if (!$event.metaKey) { return null; }
        $event.stopPropagation();
        return _vm.$emit("dayview:multiselect", _vm.event)
      }, function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.$emit("click", _vm.event)
      }]
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.event.loading),
      expression: "event.loading"
    }],
    attrs: {
      "indeterminate": true
    }
  }), _vm._v(" "), _c('div', [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.tooltips.invoiceable = !_vm.tooltips.invoiceable
      }
    },
    model: {
      value: (_vm.tooltips.invoiceable),
      callback: function($$v) {
        _vm.$set(_vm.tooltips, "invoiceable", $$v)
      },
      expression: "tooltips.invoiceable"
    }
  }, [(_vm.event.invoiceable) ? _c('v-icon', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "activator",
      "color": "amber",
      "small": ""
    },
    slot: "activator"
  }, [_vm._v("check")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Ready for invoicing")])], 1), _vm._v(" "), (_vm.event.is_online) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "dark": "",
            "small": ""
          }
        }, on), [_vm._v("headset_mic")])]
      }
    }], null, false, 1133836527)
  }, [_vm._v(" "), _c('span', [_vm._v("This meeting is online")])]) : _vm._e(), _vm._v(" "), (_vm.event.is_recurring) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "small": "",
            "dark": ""
          }
        }, on), [_vm._v("replay")])]
      }
    }], null, false, 1234321467)
  }, [_vm._v(" "), _c('span', [_vm._v("Recurring appointment")])]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.start) + " - " + _vm._s(_vm.event.end))]), _vm._v(".\n    "), (_vm.event.title) ? _c('span', [_vm._v(_vm._s(_vm.event.title))]) : _c('span', [_vm._v(_vm._s(_vm.event.full_name))]), _vm._v(" "), (_vm.infoIsTeamAccount && _vm.event.space_color && _vm.event.duration > 20) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "white--text",
          staticStyle: {
            "font-size": "8px"
          },
          attrs: {
            "color": _vm.event.space_color,
            "size": "12"
          }
        }, on), [(_vm.event.space_name) ? [_vm._v(_vm._s(_vm.event.space_name[0]))] : (_vm.event.service_name) ? [_vm._v(_vm._s(_vm.event.service_name[0]))] : _vm._e()], 2)]
      }
    }], null, false, 4033819650)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.event.space_name || _vm.event.service_name))])]) : _vm._e(), _vm._v(" "), (_vm.event.product_color && _vm.event.duration > 20) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticClass: "white--text",
          staticStyle: {
            "font-size": "8px"
          },
          attrs: {
            "color": _vm.event.product_color,
            "size": "12"
          }
        }, on), [(_vm.event.product_name) ? [_vm._v(_vm._s(_vm.event.product_name[0]))] : _vm._e()], 2)]
      }
    }], null, false, 4003189756)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.event.product_name))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14693120","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/DayEvent.vue
// module id = 1332
// module chunks = 9